export default "__VITE_ASSET__Ddix2S12__"